{
  "confirmationNumber": "확인 번호 {number}",
  "dateTimeRange": "{date} {startTime}~{endTime}"
}
